export const money = new Intl.NumberFormat("vi-VN", {
	style: "currency",
	currency: "VND",
});
export function funcFormatCurrency(numbner) {
	return money.format(numbner);
}